import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-92f69072"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "travel_details"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1));

const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_5 = {
  class: "base_details_content_second"
};
const _hoisted_6 = {
  class: "input_alert"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他设置", -1));

const _hoisted_8 = {
  class: "content"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "规格设置 ", -1));

const _hoisted_10 = {
  class: "base_details_content_second"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "产品亮点", -1));

const _hoisted_12 = {
  class: "base_details_content_second"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "行程安排", -1));

const _hoisted_14 = {
  class: "base_details_content_second"
};
import UploadVideo from "@com/upload/UploadVideo.vue";
import BackTitleView from "@com/BackTitleView.vue";
import SelectCity from "@com/SelectCity.vue";
import MapSelectAddress from "@com/MapSelectAddress.vue";
import { ref, reactive, nextTick, watch } from 'vue';
import useRoute from "@util/router";
import { Warning } from "@element-plus/icons-vue";
import api from "@api/lineManager";
import lineTypeApi from "@api/lineType";
import lineAreaApi from "@api/lineArea";
import $ from "@util/base";
import { $box, $msg } from "@/common/ui/msg";
import travelConfigApi from "@/api/travelConfig";
export default {
  __name: 'LineDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var isApproval = false;
    var title = "线路详情";
    var modifyMode = false;
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "线路详情";
        getConfig();
        getData();
      },
      add: () => {
        title = "新增线路";
        getConfig();
      },
      modify: () => {
        modifyMode = true;
        title = "修改线路";
        getConfig();
        getData();
      },
      examine: () => {
        readOnly = true;
        isApproval = true;
        title = "线路详情";
        getConfig();
        getData();
      }
    });
    const programme = ref([]);
    const attrOptions = ref([]);
    const typeOptions = ref([]);
    const areaOptions = ref([]);
    const subAreaOptions = ref([]);
    const provinceOptions = ref([]);

    function getConfig() {
      lineTypeApi.lineTypeSpecs(val => {
        typeOptions.value = val;
      });
      lineAreaApi.chooseList(val => {
        areaOptions.value = val.parentItemList;
      });
      travelConfigApi.province(val => {
        provinceOptions.value = val;
      });
    }

    const goodsSpecs = ref(null);
    const activeName = ref(0);

    function tabChange(type) {
      if (activeName.value == 0) {
        basicFormRef.value.validate((valid, fields) => {
          if (valid) {
            activeName.value = Number(activeName.value) + 1;
            setTimeout(() => {
              document.getElementById("scrollTop").scrollIntoView();
            }, 300);
          } else {
            $msg.error("请完善基本信息");
          }
        });
        return;
      }

      if (type == "next") {
        activeName.value = Number(activeName.value) + 1;
      } else {
        activeName.value = Number(activeName.value) - 1;
      }
    }

    const basicFormRef = ref(null);
    const basicForm = ref({
      lineTypeId: [],
      lineName: null,
      departure: null,
      destination: null,
      detailedAddress: null,
      destLat: null,
      destLng: null,
      picList: [],
      videoList: [],
      descList: [],
      flowStatus: null,
      flowCode: null,
      deadlineTimeDay: null,
      deadlineTimeHour: null,
      deadlineTimeMinute: null,
      typeAttrItemList: [],
      areaCode1: null,
      areaCode2: null,
      lineAreas: [] // stockNum: null

    });

    function setDeparture(value) {
      basicForm.value.departure = value;
    }

    function selectAddress(data) {
      basicForm.value.destLat = data.lat + "";
      basicForm.value.destLng = data.lng + "";
      basicForm.value.detailedAddress = data.address;
    }

    function setTargetCode(value) {
      basicForm.value.detailedAddress = value;
    }

    const basicRules = {
      lineName: [{
        required: true,
        message: "请输入线路名称",
        trigger: "blur"
      }],
      // lineTypeId: [{
      //   required: true,
      //   message: '请选择线路类型',
      //   trigger: 'change',
      // }],
      areaCode1: [{
        required: true,
        message: '请选择线路区域',
        trigger: 'change'
      }],
      destination: [{
        required: true,
        message: '请选择目的地',
        trigger: 'change'
      }],
      picList: [{
        required: true,
        type: "array",
        message: "请上传线路封面",
        trigger: "blur"
      }]
    };
    const routeManager = ref(null);
    const routeManagerData = ref([]);
    const typeAttrItemManager = ref(null);
    const typeAttrItemData = ref([]);

    function setDeadlineTime() {
      if ($.isEmpty(basicForm.value.deadlineTimeDay) && $.isEmpty(basicForm.value.deadlineTimeHour) && $.isEmpty(basicForm.value.deadlineTimeMinute)) {
        basicForm.value.deadlineTime = null;
        return true;
      } else {
        var time = [0, 0, 0];

        if ($.isNotEmpty(basicForm.value.deadlineTimeDay)) {
          time[0] = parseInt(basicForm.value.deadlineTimeDay);
        }

        if ($.isNotEmpty(basicForm.value.deadlineTimeHour)) {
          time[1] = parseInt(basicForm.value.deadlineTimeHour);
        }

        if ($.isNotEmpty(basicForm.value.deadlineTimeMinute)) {
          time[2] = parseInt(basicForm.value.deadlineTimeMinute);
        }

        basicForm.value.deadlineTime = time;
      }
    }

    var intervalSave = $.interval(save, 2500);

    function save(isExamine) {
      basicFormRef.value.validate((valid, fields) => {
        if (valid) {
          setDeadlineTime(); // if (basicForm.value.lineAreas.length > 0) {
          //   basicForm.value.areaCode1 = basicForm.value.lineAreas[0];
          //   basicForm.value.areaCode2 = basicForm.value.lineAreas[1];
          // }
          //校验基本信息

          let paramsData = {
            isPass: isExamine ? 2 : 1,
            // 是否提交审核 1 不提交 2提交审核
            lineItem: basicForm.value,
            linePlanItems: []
          };

          if ($.isNotEmpty(paramsData.lineItem.lineTypeId)) {
            paramsData.lineItem.lineTypeId = paramsData.lineItem.lineTypeId.join(",");
          } else {
            paramsData.lineItem.lineTypeId = null;
          } // 规格设置


          let typeAttrItemData = typeAttrItemManager.value.getValue();

          if (typeAttrItemData != null) {
            paramsData.lineItem.typeAttrItemList = typeAttrItemData.map(e => {
              return {
                typeAttr: e.typeAttr,
                typeAttrValues: e.typeAttrValues.join(",")
              };
            });
          } else {
            $msg.error("请完善规格设置");
            return;
          } // 行程安排


          let routeData = routeManager.value.getValue();

          if (routeData != false) {
            paramsData.linePlanItems = routeData;
            $.handleCRU(urlQuery.type, {
              add: () => {
                api.add(paramsData, () => {
                  $msg.succ("保存成功");
                  route.go(-1);
                });
              },
              modify: () => {
                api.update(paramsData, () => {
                  $msg.succ("保存成功");
                  route.go(-1);
                });
              }
            });
          }
        } else {
          $msg.error("请完善基本信息");
        }
      });
    }

    function getData() {
      api.get(route.query().lineCode, val => {
        basicForm.value = val.lineItem;
        routeManagerData.value = val.linePlanItems;
        typeAttrItemData.value = val.lineItem.typeAttrItemList;
        let lineItem = val.lineItem;

        if ($.isNotEmpty(lineItem.lineTypeId)) {
          lineItem.lineTypeId = lineItem.lineTypeId.split(",").map(e => {
            return parseInt(e);
          });
        } else {
          lineItem.lineTypeId = [];
        }

        initData();
      });
    }

    function initData() {
      if ($.isEmpty(typeAttrItemData.value)) {
        typeAttrItemData.value = [{
          typeAttr: null,
          typeAttrValues: [{
            value: null
          }],
          typeAttrItemList: []
        }];
      } else {
        typeAttrItemData.value.map(e => {
          e.tempId = $.uuid8();
          e.typeAttrValues = e.typeAttrValues.map(e => {
            return {
              value: e
            };
          });
          return e;
        });
      }

      if (basicForm.value.areaCode1 && basicForm.value.areaCode1.length > 0) {
        console.log(areaOptions.value.find(e => e.code == basicForm.value.areaCode1));
        subAreaOptions.value = areaOptions.value.find(e => e.code == basicForm.value.areaCode1).children;
      }
    } // 审批通过


    function approvalPass() {
      $box.open("通过", "确认该商品审批通过", () => {
        api.approval(basicForm.value.flowCode, "1007004", "", () => {
          $msg.succ("审批成功");
          route.go(-1);
        });
      });
    } // 驳回


    function approvalRefusal() {
      $box.input("确认驳回", "驳回原因", null, val => {
        api.approval(basicForm.value.flowCode, "1007003", val, () => {
          $msg.succ("驳回成功");
          route.go(-1);
        });
      });
    }

    const lineAreasChange = val => {
      subAreaOptions.value = areaOptions.value.find(e => e.code == val).children;
      basicForm.value.areaCode2 = null;
    };

    return (_ctx, _cache) => {
      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_UploadPicture = _resolveComponent("UploadPicture");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_LineSpecs = _resolveComponent("LineSpecs");

      const _component_RouteManager = _resolveComponent("RouteManager");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => activeName.value = $event),
            type: "border-card",
            class: "base_details_tabs",
            lazy: false
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              name: 0
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
                ref_key: "basicFormRef",
                ref: basicFormRef,
                model: basicForm.value,
                disabled: _unref(readOnly),
                rules: basicRules,
                "label-width": "100px",
                class: "base_details_form"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "线路类型",
                  prop: "lineTypeId"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                    modelValue: basicForm.value.lineTypeId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => basicForm.value.lineTypeId = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, item => {
                      return _openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "是否推荐",
                  prop: "isPush"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_switch, {
                    modelValue: basicForm.value.isPush,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => basicForm.value.isPush = $event),
                    "active-value": 1,
                    "active-text": "是",
                    "inactive-value": 0,
                    "inactive-text": "否",
                    disabled: _unref(readOnly) || _ctx.isModify
                  }, null, 8, ["modelValue", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "线路区域",
                  prop: "areaCode1",
                  required: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.value.areaCode1,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => basicForm.value.areaCode1 = $event),
                    placeholder: "请选择",
                    disabled: _unref(readOnly) || _ctx.isModify,
                    onChange: lineAreasChange
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.code
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])]),
                  _: 1
                }), basicForm.value.areaCode1 && basicForm.value.areaCode1 != '' && subAreaOptions.value && subAreaOptions.value.length > 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "二级区域",
                  prop: "areaCode2"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.value.areaCode2,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => basicForm.value.areaCode2 = $event),
                    placeholder: "请选择",
                    disabled: _unref(readOnly) || _ctx.isModify
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subAreaOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.code
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])]),
                  _: 1
                })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
                  label: "线路名称",
                  prop: "lineName"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.lineName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => basicForm.value.lineName = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "出发地",
                  prop: "departure"
                }, {
                  default: _withCtx(() => [_createVNode(SelectCity, {
                    value: basicForm.value.departure,
                    onSetCityCode: setDeparture
                  }, null, 8, ["value"]), _createElementVNode("span", _hoisted_6, [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(Warning))]),
                    _: 1
                  }), _createTextVNode(" 出发地为空时，默认从全国出发 ")])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "目的地",
                  prop: "destination"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.value.destination,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => basicForm.value.destination = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinceOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "详细地址"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.detailedAddress,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => basicForm.value.detailedAddress = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"]), _createVNode(MapSelectAddress, {
                    class: "selectMap",
                    position: [basicForm.value.destLng, basicForm.value.destLat],
                    onSelect: selectAddress,
                    disabled: _unref(readOnly)
                  }, null, 8, ["position", "disabled"])])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "线路封面",
                  prop: "picList"
                }, {
                  default: _withCtx(() => [_createVNode(_component_UploadPicture, {
                    modelValue: basicForm.value.picList,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => basicForm.value.picList = $event),
                    limit: 10,
                    imgSize: _unref($).describeImgSize(),
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "imgSize", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "线路视频",
                  prop: "videoList"
                }, {
                  default: _withCtx(() => [_createVNode(UploadVideo, {
                    modelValue: basicForm.value.videoList,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => basicForm.value.videoList = $event),
                    limit: 1,
                    fileSize: _unref($).videoFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "线路详情",
                  prop: "descList"
                }, {
                  default: _withCtx(() => [_createVNode(_component_UploadPicture, {
                    modelValue: basicForm.value.descList,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => basicForm.value.descList = $event),
                    limit: 10,
                    imgSize: _unref($).describeImgSize(),
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "imgSize", "fileSize", "disabled"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["model", "disabled"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: 1
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_7]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_LineSpecs, {
                ref_key: "typeAttrItemManager",
                ref: typeAttrItemManager,
                data: typeAttrItemData.value,
                travelProgramme: attrOptions.value,
                readOnly: _unref(readOnly)
              }, null, 8, ["data", "travelProgramme", "readOnly"])]), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_form, {
                "label-width": "100px",
                class: "base_details_form",
                disabled: _unref(readOnly)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "产品亮点"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.features,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => basicForm.value.features = $event),
                    type: "textarea",
                    rows: 3,
                    placeholder: "请输入",
                    clearable: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["disabled"])]), _hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_RouteManager, {
                ref_key: "routeManager",
                ref: routeManager,
                data: routeManagerData.value,
                travelProgramme: programme.value,
                readOnly: _unref(readOnly)
              }, null, 8, ["data", "travelProgramme", "readOnly"])])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 512), [[_vShow, activeName.value == 0]]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = $event => tabChange('last'))
          }, {
            default: _withCtx(() => [_createTextVNode("上一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value != 0]]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = $event => tabChange('next')),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("下一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value != 1]]), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[15] || (_cache[15] = $event => _unref(intervalSave)(false))
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value == 1]]) : _createCommentVNode("", true), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[16] || (_cache[16] = $event => _unref(intervalSave)(true))
          }, {
            default: _withCtx(() => [_createTextVNode("保存并提交审核 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value == 1]]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: approvalPass,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批通过 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 2 && basicForm.value.flowStatus == '1007002']]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            onClick: approvalRefusal,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批驳回 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value === 2 && basicForm.value.flowStatus == '1007002']]) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};